// extracted by mini-css-extract-plugin
module.exports = {"localeSwitcherChoices":"LocaleSwitcherDropdown_localeSwitcherChoices__GzZYa","localeSwitcherToggleOpen":"LocaleSwitcherDropdown_localeSwitcherToggleOpen__AfX_l"};